import { useState } from 'react';

import { Button } from '~/components/Button';
import FormField from '~/components/Form/FormField';
import SelectInput from '~/components/Form/SelectInput';
import TextArea from '~/components/Form/TextArea';
import TextInput from '~/components/Form/TextInput';

const subjectOptions = [
  {
    displayValue: 'Where is my order?',
    isBuyer: true,
    value: 'Where is my order? - Sole Market Buyer'
  },
  {
    displayValue: 'Cancel my order',
    isBuyer: true,
    value: 'Cancel my order - Sole Market Buyer'
  },
  {
    displayValue: 'Wrong size',
    isBuyer: true,
    value: 'Wrong size - Sole Market Buyer'
  },
  {
    displayValue: 'General Buyer enquiry',
    isBuyer: true,
    value: 'General Buyer enquiry - Sole Market Buyer'
  },
  {
    displayValue: 'General Seller enquiry',
    value: 'General Seller enquiry - Sole Market Seller'
  },
  {
    displayValue: 'Other',
    value: 'Other'
  }
];

export default function ContactForm({
  errors,
  success
}: {
  errors?: string[];
  success?: boolean;
}) {
  const [selectedSubject, setSelectedSubject] = useState<string | undefined>();

  const showOrderNumberField = subjectOptions.find(
    (s) => s.value === selectedSubject
  )?.isBuyer;

  return (
    <>
      <form
        method="post"
        action="/contact/?index"
        className="flex w-full flex-col items-start justify-center gap-4"
      >
        <FormField label="Name" htmlFor="name">
          <TextInput
            id="name"
            name="name"
            type="text"
            error={
              errors?.includes('name') ? 'Please enter a valid name' : undefined
            }
            placeholder="Enter your name"
            required
          />
        </FormField>

        <FormField label="Email Address" htmlFor="email">
          <TextInput
            id="email"
            name="email"
            type="email"
            error={
              errors?.includes('email')
                ? 'Please enter a valid email'
                : undefined
            }
            placeholder="Enter your email address"
            required
          />
        </FormField>

        <FormField label="Subject" htmlFor="subject">
          <SelectInput
            id="subject"
            placeholder="Select your subject"
            required
            name="subject"
            options={subjectOptions}
            onChange={(e) => setSelectedSubject(e.currentTarget.value)}
          />
        </FormField>

        {showOrderNumberField && (
          <FormField
            label="Sole Market order number"
            htmlFor="order_number"
            optional
          >
            <TextInput
              id="order_number"
              name="order_number"
              type="text"
              error={
                errors?.includes('order_number')
                  ? 'Please enter a valid order number'
                  : undefined
              }
              placeholder="Enter your Sole Market order number"
              required={false}
            />
          </FormField>
        )}

        <FormField label="Message" htmlFor="message">
          <TextArea name="message" required />
        </FormField>

        <Button variant="forest" type="submit" className="mx-auto mt-4 w-full">
          Submit
        </Button>
      </form>
      {success && (
        <p className="mt-4 rounded bg-concrete p-4 text-center">
          Message sent!
        </p>
      )}
      {success === false && (
        <p className="mt-4 rounded bg-concrete p-4 text-center">
          Something went wrong, please try again.
        </p>
      )}
    </>
  );
}
